import React from 'react';
import {ContestHeader} from "@/features/contest/ContestHeader.jsx";
import {MatchCard} from "@/features/contest/MatchCard.jsx";

export const GameLayout = ({contestData, slug, matchScore, isGoalFlashing, onTeamClick, children}) => {
    return (
        <>
            <ContestHeader contestData={contestData} slug={slug} recentGoal={isGoalFlashing}/>

            {contestData ? (
                <div className="px-6 pb-8 relative z-20">
                    <MatchCard
                        fixture={contestData.fixture}
                        matchScore={matchScore}
                        isGoalFlashing={isGoalFlashing}
                        onTeamClick={onTeamClick}
                    />
                    {children}
                </div>
            ) : (
                <div className="animate-fade-in relative z-20">
                    {children}
                </div>
            )}
        </>
    );
};